import {SportstypeSpec} from "../types";
import main from "../../icons/news/main";

const news: SportstypeSpec = {
  id: 'news',
  svg: main,
  releaseStage: 'released',
  events: []
}

export default news
